import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import useBehaviour, { behaviours } from './utils/use-behaviour';
var navbarClassName = 'react-navigation_navbar';

var Navbar = function Navbar(_ref) {
  var placement = _ref.placement,
      behaviour = _ref.behaviour,
      children = _ref.children,
      className = _ref.className;
  var navbarRef = useRef(null);

  var _useBehaviour = useBehaviour({
    navbarRef: navbarRef,
    behaviour: behaviour,
    placement: placement
  }),
      _useBehaviour2 = _slicedToArray(_useBehaviour, 2),
      behaviourData = _useBehaviour2[0],
      setBehaviourProps = _useBehaviour2[1];

  useEffect(function () {
    setBehaviourProps({
      navbarRef: navbarRef,
      behaviour: behaviour,
      placement: placement
    });
  }, [setBehaviourProps, navbarRef, behaviour, placement]);
  var navbarClassNames = classNames(navbarClassName, "".concat(navbarClassName, "-").concat(placement), behaviourData.className, className);
  return /*#__PURE__*/React.createElement("nav", Object.assign({}, behaviourData.attributes, {
    ref: navbarRef,
    className: navbarClassNames
  }), children);
};

Navbar.defaultProps = {
  placement: 'top'
};
export default Navbar;